import { Chip } from '@toggle/design-system';
import clsx from 'clsx';
import React, { HTMLAttributes } from 'react';

import styles from './ChoiceChips.module.scss';

export interface ChoiceItem<T> {
  id: T;
  label: string;
}

export interface ChoiceChipsProps<T = ChoiceItem<string>>
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  disabledItems?: T[];
  items: T[];
  onChange: (item: T) => void;
  selectedItem: T | null;
}

export const ChoiceChips = <T extends ChoiceItem<string>>({
  disabledItems = [],
  items,
  onChange,
  selectedItem,
  className,
  ...rest
}: ChoiceChipsProps<T>) => {
  return (
    <div
      data-testid="choice-chips"
      className={clsx(styles.choiceChipsRoot, className)}
      {...rest}
    >
      {items.map(item => (
        <Chip
          data-testid={`${item.id}-chip`}
          key={item.id}
          label={item.label}
          type="choice"
          disabled={disabledItems.includes(item)}
          isActive={item === selectedItem}
          onClick={() => onChange(item)}
        />
      ))}
    </div>
  );
};
